import type { I18nOptions } from "#i18n";

import { availableLocales } from "./i18nConfig";

export const vueI18nConfigOptions = {
  legacy: false,
  fallbackLocale: "en",
  warnHtmlInMessage: "off",
  warnHtmlMessage: false,
  availableLocales: availableLocales.map((locale) => locale.code),
} satisfies I18nOptions;

/**
 * vue-i18n configuration. this file is pointed to by the @nuxtjs/i18n module config in `i18nConfig.ts`
 */
export default defineI18nConfig(() => vueI18nConfigOptions);
